import { Button, Form, message, notification, TablePaginationConfig } from 'ant-design-vue';
import axios from 'axios';
import { AxiosRequestHeaders } from 'axios';
import i18n from '@/langs';
const { t } = i18n.global;

import { backToLogin, gotoAuthPassword2 } from '@/router';
import { h } from 'vue';

export const API_BASE_URL = '/api';

const apiAxios = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
});

const csrfTokenUri = '/csrf-token';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const apiErrorExecute = (err: any) => {
    const res = err.response;
    const hasMsg = (res.data && res.data.message);

    if (hasMsg) {
        switch (res.data.message) {
           case 'unauthorized':
                backToLogin();
                break;

            case 'unauthorized_pw2':
                gotoAuthPassword2();
                break;
        }
    } else {
        notification.error({
            message: 'Lỗi không xác định',
            description: 'Nếu bạn nhìn thấy lỗi này, hãy thử tải lại trang, nếu vẫn không được, hãy liên hệ với quản trị viên.',
            placement: 'bottomLeft',
            btn: () => h(
                Button,
                {
                    type: 'primary',
                    onClick: () => window.location.reload(),
                },
                { default: () => 'Tải lại trang' },
            ),
            duration: 0,
            key: 'api-error-no-message',
        });
    }

    message.error({
        key: 'apiErrorExecMSG',
        content: hasMsg ? t('message.apiError.' + res.data.message) : (res.statusText || err.message),
    });

    throw err;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleError<T> (err: any, formExtraError: { [key in keyof T]: string }, form?: typeof Form) {
    if (err.response?.status === 422) {
        const { errors } = err.response.data;
        for (const k of (Object.keys(errors) as (keyof T)[])) {
            for (const v of (errors[k] as string)) {
                const tData = v.split(':');
                const tKey = tData[0];
                const tValue: {[k: string]: string} = {};
                switch (tKey) {
                    case 'wait_try_again':
                        tValue.seconds = tData[1];
                        break;
                }

                formExtraError[k] += t(`message.validError.${tKey}`, tValue);
            }
        }
        form?.validate().catch(() => {
            for (const k of (Object.keys(formExtraError) as (keyof T)[])) {
                formExtraError[k] = '';
            }
        });
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setPaginate(pagination: TablePaginationConfig, resData: any) {
    pagination.current = resData.current_page;
    pagination.pageSize = resData.per_page;
    pagination.total = resData.total;
    pagination.showTotal = (total: number) => `Total ${total} items`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function get(uri: string, queries?: any, headers?: AxiosRequestHeaders) {
    return apiAxios.get(uri, {
        params: queries,
        headers,
    }).catch(apiErrorExecute);
}

export async function post(uri: string, data?: object, headers?: AxiosRequestHeaders) {
    return get(csrfTokenUri, null, headers).then(async () => {
        return apiAxios.post(uri, data).catch(apiErrorExecute);
    });
}

export async function patch(uri: string, data?: object, headers?: AxiosRequestHeaders) {
    return get(csrfTokenUri, null, headers).then(async () => {
        return apiAxios.patch(uri, data).catch(apiErrorExecute);
    });
}

export async function del(uri: string, headers?: AxiosRequestHeaders) {
    return get(csrfTokenUri, null, headers).then(async () => {
        return apiAxios.delete(uri, { headers }).catch(apiErrorExecute);
    });
}

export default {
    get, post, patch, del,
    handleError, setPaginate, API_BASE_URL,
}
